module.exports = __webpack_public_path__ + "media/images/stand-fabbe9a1.png";